import { useDisclosure } from '@chakra-ui/hooks';
import { Flex, Tooltip } from '@chakra-ui/react';
import { FC } from 'react';

import ICAward from '@/assets/icons/ic-award.svg';

interface ILectureAwardTooltip {
  award?: string;
}

export const LectureCardAwardCircleTooltip: FC<ILectureAwardTooltip> = ({ award }) => {
  const { isOpen, onOpen, onToggle, onClose } = useDisclosure();

  if (!award) return;
  return (
    <Tooltip
      label={award}
      bg="white"
      hasArrow
      maxW={{ base: 'xs', lg: '4xl' }}
      placement="top"
      wordBreak="break-all"
      isOpen={isOpen}
    >
      <Flex
        tabIndex={0}
        role="button"
        aria-label="Show award"
        onClick={(e) => {
          onToggle();
          e.stopPropagation();
          e.preventDefault();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          }
        }}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        onFocus={onOpen}
        onBlur={onClose}
        bgColor="white"
        _hover={{ border: '2px solid #E3E5E5' }}
        justifyContent="center"
        alignItems="center"
        w={10}
        h={10}
        borderRadius="50%"
        backgroundColor="white"
      >
        <ICAward />
      </Flex>
    </Tooltip>
  );
};
